/* eslint-disable */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validation } from '../../shared/services/validation.service';
import { ModalService } from '../../shared/services/modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'md-textarea',
  template: require('./textarea.component.html')
})

export class TextareaComponent {
  @Input() options;


  constructor(modal: ModalService, router: Router) {
    this.modal = modal;
    this.router = router;
  }

  openModel(event) {
    this.modal.agreementsModel(this.options.pdfLink, this.options.text);
  }
}
